import { render } from "./FpSplashError.vue?vue&type=template&id=f572e958&lang=pug"
import script from "./FpSplashError.vue?vue&type=script&lang=js"
export * from "./FpSplashError.vue?vue&type=script&lang=js"

import "./FpSplashError.vue?vue&type=style&index=0&id=f572e958&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__